export function arrayObjectIndexOf(myArray, searchTerm, property) {
  return objectIndexOf(myArray, searchTerm, property);
}

function objectIndexOf(myArray, searchTerm, property) {
  let result = -1;
  myArray.forEach((item, i) => {
    if (result == -1 && item[property] == searchTerm) {
      result = i;
    }
  });
  return result;
}

export function getAllChildren(dataAray, myArray, propertyParent, propertyChildren) {
  //propertyParent: donViHanhChinhID
  //propertyChildren: donViHanhChinhCha
  let dataResult = [...myArray];

  myArray.forEach(item => {
    let Result = getChildren(dataAray, myArray, item.value, propertyParent, propertyChildren);
    dataResult = [...dataResult, ...Result];
  });
  return dataResult;
}

export function removeAllChildren(inputArray) {
  //propertyParent: donViHanhChinhID
  //propertyChildren: donViHanhChinhCha
  let outputArray = inputArray.filter(item => {
    return item.isChild != true
  });
  return outputArray;
}

function getChildren(dataAray, myArray, value, propertyParent, propertyChildren) {
  let dataResult = dataAray.filter(item => {
    return item[propertyChildren] && item[propertyChildren][propertyParent] == value
  })
  let dataReturn = [];
  if (dataResult.length > 0) {
    dataResult.forEach(item => {
      if (objectIndexOf(myArray, item[propertyParent], 'value') == -1) {
        dataReturn = [...dataReturn, {
          value: item[propertyParent],
          label: item.ten,
          isChild: true
        }];
      }
      let dataReGet = getChildren(dataAray, myArray, item[propertyParent], propertyParent, propertyChildren);
      if (dataReGet.length > 0) {
        dataReturn = [
          ...dataReturn,
          ...dataReGet
        ]
      }
    });
  }

  return dataReturn;
}


// WEBPACK FOOTER //
// ./src/components/tt-forms/react-tree-select/method.jsx